module.exports = __webpack_public_path__ + "img/SMT_47_Linda_Chew.d05662e1.jpg";